import { render, staticRenderFns } from "./MainPage.vue?vue&type=template&id=7c363204&scoped=true"
import script from "./MainPage.vue?vue&type=script&lang=js"
export * from "./MainPage.vue?vue&type=script&lang=js"
import style0 from "@/styles/views/MainPage/MainPage.less?vue&type=style&index=0&id=7c363204&prod&lang=less&scoped=true&external"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7c363204",
  null
  
)

export default component.exports